import React from 'react';
import { IconProps } from '.';

const SvgColoredAnalysis = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='url(#ColoredAnalysis_svg__a)'
        d='M3.625 1.5C2.451 1.5 1.5 2.675 1.5 4.125v15.75c0 1.45.951 2.625 2.125 2.625h12.75c.672 0 1.272-.386 1.661-.988l-.21-.21a6.003 6.003 0 1 1 .674-10.18V4.126c0-1.45-.951-2.625-2.125-2.625H3.625Z'
      />
      <path fill='url(#ColoredAnalysis_svg__b)' d='M17.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z' />
      <path
        fill='#878F91'
        d='M9.042 16.719A.258.258 0 0 0 9 16.707l-.102-.018a.249.249 0 0 0-.135.012l-.105.041a.25.25 0 1 0 .181.466l.04-.015.031.006a.25.25 0 0 0 .2-.05 5.987 5.987 0 0 1-.068-.43ZM4.055 15.594a.25.25 0 0 1 .35-.04l.084.067a.25.25 0 1 1-.311.391l-.084-.067a.25.25 0 0 1-.04-.35ZM4.807 16.194a.25.25 0 0 1 .35-.04l.168.134a.25.25 0 0 1-.312.39l-.167-.133a.25.25 0 0 1-.04-.35ZM5.642 16.86a.25.25 0 0 1 .351-.039l.168.134a.25.25 0 1 1-.312.39l-.167-.133a.25.25 0 0 1-.04-.351ZM8 17.535a.25.25 0 0 0-.18-.466l-.21.081a.25.25 0 0 0 .18.466l.21-.081ZM6.799 17.467a.25.25 0 0 0-.282.412l.084.066a.25.25 0 0 0 .246.038l.105-.04a.25.25 0 0 0-.153-.476ZM11.15 11.4H5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4.592a6.025 6.025 0 0 1 1.557-2ZM4.5 5.9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-1ZM18.5 8.936V6.891h-1.438l-2.414.65A2.499 2.499 0 0 0 18.5 8.935ZM5 8.4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H5Z'
      />
      <path fill='#F4847D' d='M4 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1Z' />
      <path fill='#5AC27C' d='M4 5.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-1Z' />
      <path
        fill='#7463F2'
        d='m21.816 21.796-2.72-2.72a5.024 5.024 0 0 0 1.007-3.024A5.057 5.057 0 0 0 15.051 11 5.057 5.057 0 0 0 10 16.052a5.057 5.057 0 0 0 5.052 5.051 5.024 5.024 0 0 0 3.023-1.007l2.72 2.72a.723.723 0 0 0 1.021-1.02Zm-10.373-5.744a3.608 3.608 0 1 1 7.217 0 3.608 3.608 0 0 1-7.217 0Z'
      />
      <path fill='#FCC167' d='M17.013 4a2.5 2.5 0 1 1-2.365 3.149l2.414-.65L17.013 4Z' />
      <path fill='#51BEF7' d='M11.684 11H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5.304a6.033 6.033 0 0 1 1.88-2Z' />
      <defs>
        <linearGradient
          id='ColoredAnalysis_svg__a'
          x1={4.688}
          x2={20.125}
          y1={3.25}
          y2={21.094}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E7E7ED' />
          <stop offset={1} stopColor='#F1F1F8' />
        </linearGradient>
        <linearGradient
          id='ColoredAnalysis_svg__b'
          x1={4.688}
          x2={20.125}
          y1={3.25}
          y2={21.094}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E7E7ED' />
          <stop offset={1} stopColor='#F1F1F8' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgColoredAnalysis;
